import Splide from '@splidejs/splide';

document.querySelectorAll('.js-title-carousel').forEach((el) => {
  new Splide(el, {
    type: 'fade',
    rewind: true,
    arrows: false,
    pagination: false,
    autoplay: true,
    interval: 3000,
    speed: 600,
    pauseOnHover: false,
    pauseOnFocus: false,
  }).mount();
});
